import get from 'lodash/get';
import React, {Component} from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import {generateNextChoiceId} from '../../../services/idHelpers';
import MinusButton from './MinusButton';
import PlusButton from './PlusButton';
import UpButton from './UpButton';
import DownButton from './DownButton';
import Error from '../../Error';
import DraggableCell from './DraggableCell';
import DraggableRow from './DraggableRow';
import DragDropTableBody from './DragDropTableBody';

class ChoiceType extends Component {
    constructor(props) {
        super(props);
        this.addChoice = this.addChoice.bind(this);
    }

    addChoice() {
        const choices = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextChoiceId(choices), value: ''});
    }

    render() {
        const {remove, move, form, name} = this.props;

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col style={{width: 80}} />
                    <col style={{width: 80}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                        <th />
                    </tr>
                </thead>
                <DragDropTableBody move={move}>
                    {get(form.values, name) && get(form.values, name).map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField id={`${name}.${index}.id`} name={`${name}.${index}.id`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`)})} />
                                <ErrorMessage name={`${name}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.value`} name={`${name}.${index}.value`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.value`) && get(form.touched, `${name}.${index}.value`)})} />
                                <ErrorMessage name={`${name}.${index}.value`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell className="border-right">
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <div className="">{index > 0 && <UpButton move={move} index={index} />}</div>
                                        <div className="">{index + 1 < arr.length && <DownButton move={move} index={index} />}</div>
                                    </div>
                                </div>
                            </DraggableCell>
                            <DraggableCell>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={this.addChoice}>
                                <FormattedMessage {...messages.surveys.button.add_choice} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}

export default ChoiceType;
